import { Component, NgZone } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';

declare var google: any;

@IonicPage()
@Component({
  selector: 'page-zona-obra',
  templateUrl: 'zona-obra.html'
})
export class ZonaObraPage {
  obra: any;
  obrasDisponibles: any[] = [];
  obraDestino = '';
  mapa: any;
  poligono: any;
  puntos: Array<{ lat: number, lng: number }> = [];
  modo = 'SIN_RESTRICCION';
  cargando = true;
  guardando = false;
  mensaje = '';
  dibujando = false;
  private escuchaMapa: any;
  private escuchaClickDOM: any;
  private elementoMapa: HTMLElement;
  private proyeccionMapa: any;
  private ultimoPunto: { lat: number, lng: number, tiempo: number };
  private intentosMapa = 0;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public funciones: FuncionesProvider,
    public variables: VariablesProvider,
    private zonaAngular: NgZone
  ) {
    this.obra = this.navParams.get('obra') || {};
    this.obrasDisponibles = (this.navParams.get('obras') || [])
      .filter((obra: any) => obra && obra.NOMBRE && obra.NOMBRE !== this.obra.NOMBRE);
  }

  ionViewDidLoad() {
    this.esperarGoogleMaps();
  }

  private esperarGoogleMaps() {
    if (typeof google !== 'undefined' && google.maps && google.maps.Map) {
      this.iniciarMapa();
      return;
    }
    this.intentosMapa++;
    if (this.intentosMapa < 30) {
      setTimeout(() => this.esperarGoogleMaps(), 250);
    } else {
      this.cargando = false;
      this.mensaje = 'No se ha podido cargar el mapa. Compruebe la conexión a internet.';
    }
  }

  private iniciarMapa() {
    const elemento = document.getElementById('mapa-zona');
    if (!elemento) { return; }

    this.mapa = new google.maps.Map(elemento, {
      center: { lat: 40.4168, lng: -3.7038 },
      zoom: 6,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true
    });

    this.elementoMapa = elemento;
    this.proyeccionMapa = new google.maps.OverlayView();
    this.proyeccionMapa.onAdd = () => { };
    this.proyeccionMapa.draw = () => { };
    this.proyeccionMapa.onRemove = () => { };
    this.proyeccionMapa.setMap(this.mapa);

    this.cargarZona();
  }

  iniciarDibujo() {
    if (this.guardando || !this.mapa) { return; }
    this.detenerEscuchaMapa();
    if (this.poligono) { this.poligono.setMap(null); }
    this.puntos = [];
    this.poligono = new google.maps.Polygon({
      paths: [],
      map: this.mapa,
      fillColor: '#2e9e55',
      fillOpacity: 0.28,
      strokeColor: '#176b38',
      strokeOpacity: 0.95,
      strokeWeight: 2,
      editable: false,
      clickable: false
    });
    // Algunas versiones de Google Maps no crean MVCArray cuando Polygon
    // recibe un array vacÃ­o. Inicializamos la ruta antes del primer clic.
    this.poligono.setPath([]);
    this.mapa.setOptions({ draggable: false, draggableCursor: 'crosshair' });
    this.dibujando = true;
    this.mensaje = 'Haga clic en el mapa para añadir puntos y después pulse Terminar dibujo.';
    this.escuchaMapa = this.mapa.addListener('click', (evento: any) => {
      this.anadirPunto(evento && evento.latLng);
      this.mensaje = 'MODO DIBUJO ACTIVO: aÃ±ada mÃ¡s puntos o pulse Terminar dibujo.';
    });
    this.instalarEscuchaClickDOM();
  }

  terminarDibujo() {
    if (!this.dibujando) { return; }
    this.detenerEscuchaMapa();
    this.detenerEscuchaClickDOM();
    this.dibujando = false;
    this.mapa.setOptions({ draggable: true, draggableCursor: 'grab' });
    if (this.puntos.length < 3) {
      if (this.poligono) { this.poligono.setMap(null); }
      this.poligono = null;
      this.puntos = [];
      this.mensaje = 'La zona debe tener al menos tres puntos.';
      return;
    }
    this.poligono.setOptions({ editable: true, clickable: true });
    this.enlazarCambiosPoligono();
    this.mensaje = 'Zona dibujada. Revise el contorno y pulse Guardar zona.';
  }

  private detenerEscuchaMapa() {
    if (this.escuchaMapa) {
      this.escuchaMapa.remove();
      this.escuchaMapa = null;
    }
  }

  private instalarEscuchaClickDOM() {
    if (!this.elementoMapa || this.escuchaClickDOM) { return; }
    this.escuchaClickDOM = (evento: MouseEvent) => {
      if (!this.dibujando || !this.poligono || !this.proyeccionMapa) { return; }
      const rect = this.elementoMapa.getBoundingClientRect();
      const x = evento.clientX - rect.left;
      const y = evento.clientY - rect.top;
      if (x < 0 || y < 0 || x > rect.width || y > rect.height) { return; }
      const proyeccion = this.proyeccionMapa.getProjection();
      if (!proyeccion) { return; }
      const punto = proyeccion.fromContainerPixelToLatLng(new google.maps.Point(x, y));
      this.anadirPunto(punto);
    };
    this.elementoMapa.addEventListener('click', this.escuchaClickDOM, true);
  }

  private detenerEscuchaClickDOM() {
    if (this.elementoMapa && this.escuchaClickDOM) {
      this.elementoMapa.removeEventListener('click', this.escuchaClickDOM, true);
    }
    this.escuchaClickDOM = null;
  }

  capturarClic(evento: MouseEvent) {
    if (!this.dibujando || !this.poligono || !this.proyeccionMapa || !this.elementoMapa) { return; }
    const rect = this.elementoMapa.getBoundingClientRect();
    const pixel = new google.maps.Point(evento.clientX - rect.left, evento.clientY - rect.top);
    let intentos = 0;
    const convertir = () => {
      if (!this.dibujando) { return; }
      const proyeccion = this.proyeccionMapa.getProjection();
      if (proyeccion) {
        this.anadirPunto(proyeccion.fromContainerPixelToLatLng(pixel));
        return;
      }
      intentos++;
      if (intentos < 10) { setTimeout(convertir, 50); }
    };
    convertir();
  }

  private anadirPunto(latLng: any) {
    if (!this.dibujando || !this.poligono || !latLng) { return; }
    const lat = Number(latLng.lat());
    const lng = Number(latLng.lng());
    if (!isFinite(lat) || !isFinite(lng)) { return; }

    // El evento DOM y map.click pueden llegar juntos: no contar dos veces
    // el mismo clic.
    const ahora = Date.now();
    if (this.ultimoPunto && ahora - this.ultimoPunto.tiempo < 300 &&
      Math.abs(this.ultimoPunto.lat - lat) < 0.00001 &&
      Math.abs(this.ultimoPunto.lng - lng) < 0.00001) {
      return;
    }
    this.ultimoPunto = { lat: lat, lng: lng, tiempo: ahora };
    let path = this.poligono.getPath();
    if (!path) {
      this.poligono.setPath([]);
      path = this.poligono.getPath();
    }
    if (!path) { return; }
    path.push(latLng);
    this.zonaAngular.run(() => {
      this.leerPuntos();
      this.mensaje = 'Punto añadido. Puede marcar otra esquina o pulsar Terminar dibujo.';
    });
  }

  private cargarZona() {
    this.funciones.obtenerZonaObra(this.obra.NOMBRE).then((respuesta: any) => {
      const zona = Array.isArray(respuesta) ? respuesta[0] : respuesta;
      if (zona && Array.isArray(zona.puntos) && zona.puntos.length >= 3) {
        this.puntos = zona.puntos.map((p: any) => ({ lat: Number(p.lat), lng: Number(p.lng) }));
        this.modo = String(zona.modo || (String(zona.activo).toUpperCase() === 'SI' ? 'BLOQUEAR' : 'SIN_RESTRICCION')).toUpperCase();
        if (['BLOQUEAR', 'INCIDENCIA', 'SIN_RESTRICCION'].indexOf(this.modo) < 0) { this.modo = 'SIN_RESTRICCION'; }
        this.pintarPoligono();
      }
      this.cargando = false;
    }).catch(() => {
      this.cargando = false;
      this.mensaje = 'No se pudo leer la configuración de esta sede.';
    });
  }

  private pintarPoligono() {
    if (!this.puntos.length) { return; }
    this.poligono = new google.maps.Polygon({
      paths: this.puntos,
      map: this.mapa,
      fillColor: '#2e9e55',
      fillOpacity: 0.28,
      strokeColor: '#176b38',
      strokeOpacity: 0.95,
      strokeWeight: 2,
      editable: true
    });
    this.enlazarCambiosPoligono();
    const bounds = new google.maps.LatLngBounds();
    this.puntos.forEach(p => bounds.extend(p));
    this.mapa.fitBounds(bounds);
  }

  private enlazarCambiosPoligono() {
    if (!this.poligono) { return; }
    const path = this.poligono.getPath();
    google.maps.event.addListener(path, 'set_at', () => this.leerPuntos());
    google.maps.event.addListener(path, 'insert_at', () => this.leerPuntos());
    google.maps.event.addListener(path, 'remove_at', () => this.leerPuntos());
  }

  private leerPuntos() {
    if (!this.poligono) { this.puntos = []; return; }
    const path = this.poligono.getPath();
    if (!path) { this.puntos = []; return; }
    const resultado: Array<{ lat: number, lng: number }> = [];
    for (let i = 0; i < path.getLength(); i++) {
      const punto = path.getAt(i);
      resultado.push({ lat: Number(punto.lat().toFixed(7)), lng: Number(punto.lng().toFixed(7)) });
    }
    this.puntos = resultado;
  }

  limpiar() {
    this.detenerEscuchaMapa();
    this.detenerEscuchaClickDOM();
    this.dibujando = false;
    if (this.mapa) { this.mapa.setOptions({ draggable: true, draggableCursor: 'grab' }); }
    if (this.poligono) { this.poligono.setMap(null); }
    this.poligono = null;
    this.puntos = [];
    this.modo = 'SIN_RESTRICCION';
    this.mensaje = 'Zona eliminada del mapa. Pulse Guardar para confirmar.';
  }

  guardar() {
    if (this.puntos.length > 0 && this.puntos.length < 3) {
      this.mensaje = 'La zona debe tener al menos tres puntos.';
      return;
    }
    this.guardando = true;
    this.funciones.guardarZonaObra(
      this.obra.NOMBRE,
      this.modo,
      this.puntos
    ).then((respuesta: any) => {
      this.guardando = false;
      if (respuesta && respuesta.ok) {
        this.mensaje = this.puntos.length >= 3
          ? (this.modo === 'SIN_RESTRICCION' ? 'Zona guardada, pero sin restricción.' : 'Zona guardada y activa.')
          : 'Zona eliminada correctamente.';
      } else {
        this.mensaje = (respuesta && respuesta.mensaje) || 'No se pudo guardar la zona.';
      }
    }).catch(() => {
      this.guardando = false;
      this.mensaje = 'No se pudo guardar la zona.';
    });
  }

  copiar() {
    if (this.puntos.length < 3 || !this.obraDestino || this.guardando) { return; }
    const confirmacion = this.alertCtrl.create({
      title: 'Copiar zona',
      message: 'Se copiará esta zona a ' + this.obraDestino + '. Si ya tenía una, será sustituida.',
      buttons: [
        { text: 'Cancelar', role: 'cancel' },
        {
          text: 'Copiar',
          handler: () => {
            this.guardando = true;
            this.funciones.guardarZonaObra(this.obraDestino, this.modo, this.puntos)
              .then((respuesta: any) => {
                this.guardando = false;
                this.mensaje = respuesta && respuesta.ok
                  ? 'Zona copiada correctamente a ' + this.obraDestino + '.'
                  : ((respuesta && respuesta.mensaje) || 'No se pudo copiar la zona.');
              })
              .catch(() => {
                this.guardando = false;
                this.mensaje = 'No se pudo copiar la zona.';
              });
          }
        }
      ]
    });
    confirmacion.present();
  }

  salir() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/zona-obra/zona-obra.ts